import scrollMonitor from 'scrollmonitor';
import bus from '../util/eventBus';

const inViewCore = item => {
  const animElements = document.querySelectorAll(item);

  animElements.forEach((el, i, arr) => {
    const elWatcher = scrollMonitor.create(el, { top: -200 });

    if (el.classList.contains('c-grid__item')) {
      Array.from(arr)
        .slice(0, 3)
        .forEach(gridItem => {
          gridItem.classList.add('is-active');
        });
    }

    elWatcher.enterViewport(() => {
      el.classList.add('is-active');
    });
  });
};

const inView = selector => {
  inViewCore(selector);

  bus.on('ewg-social-grid-recalc', () => {
    inViewCore(selector);
  });
};

export default inView;



// WEBPACK FOOTER //
// ./src/scripts/modules/inView.js